export class UserSettingsCookieModel {
  selectedLangID: Number;

  constructor(cookie: Object) {
    this.selectedLangID = cookie.selectedLangID;
  }
}
